module.exports = __webpack_public_path__ + "img/send-icon-active.3d73c9fc.svg";